<form novalidate #setupForm="ngForm">
  <div class="setup-container">
    <div class="section-container">
      <div class="section-label identity">Identity</div>
      <div class="section-data">
        <nrwl-test-identity
          [testName]="testName"
          [customer]="customerName"
          [contact]="contact"
          [email]="email"
          [phone]="phone"
          [technicianId]="technicianId"
          [comments]="comments"
          [technician]="technicianName"
          [editMode]="editMode || cloneMode"
          (updateTestIdentity)="updateTestIdentity($event)"
        ></nrwl-test-identity>
      </div>
    </div>
    <div class="section-container">
      <div class="section-label">Test Type</div>
      <div class="section-data">
        <div class="group">
          <div class="label">Test mode</div>
          <mat-select
            name="testMode"
            class="option-list width-200"
            #testModeInput="ngModel"
            [disabled]="editMode"
            [(ngModel)]="setupFormField.testMode"
            (selectionChange)="onTestModeChange()"
          >
            <mat-option *ngFor="let mode of testModes" [value]="mode.value">
              {{ mode.name }}</mat-option
            >
          </mat-select>
        </div>
        <div class="group">
          <div class="label">Layer to test</div>
          <mat-select
            name="layerToTest"
            class="option-list"
            #layerToTestInput="ngModel"
            [(ngModel)]="setupFormField.layerToTest"
            (selectionChange)="onLayerChange()"
          >
            <mat-option *ngFor="let layers of layerTypes" [value]="layers.value">{{
              layers.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group">
          <div class="label">IP Address Type</div>
          <mat-select
            name="ipAddrType"
            class="option-list"
            #ipAddrTypeInput="ngModel"
            [(ngModel)]="setupFormField.ipAddrType"
            (selectionChange)="onIpAddressTypeChange()"
          >
            <mat-option *ngFor="let ipTypes of ipAddressTypes" [value]="ipTypes.value">{{
              ipTypes.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group">
          <div class="label">Stream rate convention</div>
          <mat-select
            name="streamRateConvention"
            #streamRateInpute="ngModel"
            class="option-list"
            [(ngModel)]="setupFormField.streamRateConvention"
            (selectionChange)="onStreamRateConventionChange()"
          >
            <mat-option *ngFor="let conven of streamRateTypes" [value]="conven.value">{{
              conven.name
            }}</mat-option>
          </mat-select>
        </div>
      </div>
    </div>
    <div class="section-container">
      <div>
        <img class="icon" [attr.src]="'images/SCTIcon.svg'" />
        <div class="section-label">Configuration Test</div>
      </div>
      <div class="enable-section">
        <div class="slide-btn">
          <mat-slide-toggle
            #configToggleElement
            name="configuration"
            [checked]="setupFormField.configurationTest"
            class="enable-row"
            color="primary"
            (change)="configurationToggleChange(configToggleElement)"
          >
          </mat-slide-toggle>
          <div class="toggle-text">
            <div class="section-label">
              {{ setupFormField.configurationTest ? 'enabled' : 'disabled' }}
            </div>
          </div>
        </div>
        <div class="section-data" *ngIf="setupFormField.configurationTest">
          <div class="group">
            <div class="label">Number of Steps</div>
            <div class="field-description">Starts at a lower CIR and ramp up to 100%</div>
            <mat-select
              name="stepsCount"
              class="option-list width-75"
              #reverstepInput="ngModel"
              [(ngModel)]="setupFormField.stepsCount"
              (selectionChange)="onNumberOfStepsChange($event)"
            >
              <mat-option *ngFor="let opt of maxNumberOfSteps" [value]="opt">
                {{ opt }}
              </mat-option>
            </mat-select>
            <span class="unit-label">{{ stepPercentageDetails }}</span>
          </div>
          <div class="group" *ngIf="showFormField(configMapping.REVERSE_STEPS)">
            <div class="label">Reverse Steps</div>
            <div class="field-description">
              Start at 100% and only test lower step if higher step fails
            </div>
            <mat-select
              name="reverseSteps"
              class="option-list width-75"
              #reverstepInput="ngModel"
              [(ngModel)]="setupFormField.reverseSteps"
              (selectionChange)="onReverseStepsChange()"
            >
              <mat-option *ngFor="let opt of reverseStepOptions" [value]="opt.value">{{
                opt.name
              }}</mat-option>
            </mat-select>
          </div>
          <div class="group">
            <div class="label">Step duration *</div>
            <div class="field-description">How long to test each step</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-data width-45 float-left"
              name="stepDuration"
              #stepDurationInput="ngModel"
              [(ngModel)]="setupFormField.stepDuration"
              (ngModelChange)="onStepDurationChange()"
              min="5"
              max="60"
              required
            />
            <spa class="unit-label vert-text-mid">Sec</spa>
            <div
              class="error clr-float"
              *ngIf="
                stepDurationInput.invalid && (stepDurationInput.dirty || stepDurationInput.touched)
              "
            >
              <mat-error *ngIf="stepDurationInput?.errors?.required"
                >Step duration is required</mat-error
              >
              <mat-error *ngIf="stepDurationInput.errors?.min || stepDurationInput.errors?.max">
                value should be 5 to 60</mat-error
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-container">
      <div>
        <img class="icon" [attr.src]="'images/SPTIcon.svg'" />
        <div class="section-label">Performance Test</div>
      </div>
      <div class="enable-section">
        <div class="slide-btn">
          <mat-slide-toggle
            #perfToggleElement
            name="performance"
            [checked]="setupFormField.performanceTest"
            class="enable-row"
            color="primary"
            (change)="performanceToggleChange(perfToggleElement)"
          >
          </mat-slide-toggle>
          <div class="toggle-text">
            <div class="section-label">
              {{ setupFormField.performanceTest ? 'enabled' : 'disabled' }}
            </div>
          </div>
        </div>
        <!-- <div class="section-data" *ngIf="setupFormField.performanceTest">
          <div class="group">
            <div class="label">Test duration</div>
            <mat-select
              class="option-list"
              [(ngModel)]="setupFormField.perfTestDuration"
              name="perfTestDuration"
              (selectionChange)="onPerfTestDurationChange()"
              #testDurationInput="ngModel"
            >
              <mat-option *ngFor="let opt of testDurationOptions" [value]="opt.value">{{
                opt.name
              }}</mat-option>
            </mat-select>
          </div>
          <div class="group" *ngIf="setupFormField.perfTestDuration === 'custom'">
            <div class="label">hour:min:sec *</div>
            <input
              matInput
              autocomplete="off"
              type="text"
              class="input-data width-60"
              name="customPerfTestDuration"
              #customPerfTestDurationInput="ngModel"
              [(ngModel)]="setupFormField.customPerfTestDuration"
              placeholder="HH:MM:SS"
              (ngModelChange)="customPerfTestDurationChange()"
              [pattern]="validTestDurationRegex"
              (input)="reformatTestDuration($event)"
              maxlength="8"
              required
            />
            <div
              class="error"
              *ngIf="
                customPerfTestDurationInput.invalid &&
                (customPerfTestDurationInput.dirty || customPerfTestDurationInput.touched)
              "
            >
              <mat-error *ngIf="customPerfTestDurationInput?.errors?.required"
                >Duration is required</mat-error
              >
              <mat-error *ngIf="customPerfTestDurationInput.errors?.pattern"
                >Invalid test duration</mat-error
              >
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <div class="section-container height-120">
      <div class="section-label"><label>Schedule</label></div>
      <div class="scheduler-section">
        <viavi-scheduler
          [scheduleValue]="scheduleInfoData"
          (schedulerDataVal)="fetchSchedulerVal($event)"
          [isDisabledScheduler]="isDisabledScheduler"
          [schedulerEnds]="schedulerEnds"
        >
        </viavi-scheduler>
      </div>
    </div>
  </div>
</form>
